module.exports = __webpack_public_path__ + "img/DaiwaQ.57c978e2.png";